import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Resource, { ResourceTypeEnum } from '@/models/_deprecated/Resource';
import { useTranslation } from 'react-i18next';

type Props = {
  resource: Resource;
  onEdit(type: ResourceTypeEnum): void;
  editing?: boolean;
};

export default function ChangeResourceButton({
  resource,
  editing,
  onEdit,
}: Props) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const { t: tResourcePreview } = useTranslation('translation', {
    keyPrefix: 'resourcePreview',
  });

  type PreviewInfo = {
    text: string;
    type: ResourceTypeEnum;
  };

  const previewInfo = (resource: Resource): PreviewInfo => {
    if (resource.resourceFile) {
      return {
        text: tResourcePreview('changeResource', {
          resource: t('file'),
        }),
        type: ResourceTypeEnum.FILE,
      };
    }
    if (resource.resourceLink) {
      return {
        text: tResourcePreview('changeResource', {
          resource: 'link',
        }),
        type: ResourceTypeEnum.LINK,
      };
    }
    return { text: '', type: ResourceTypeEnum.NONE };
  };

  const info = previewInfo(resource);

  return (
    <ConditionalRenderer condition={editing}>
      <MainButton
        text={info.text}
        icon={<ArrowsRightLeftIcon />}
        color="custom"
        className="text-primary text-[0.875rem] gap-1 lowercase"
        onClick={() => onEdit(info.type)}
      />
    </ConditionalRenderer>
  );
}
